module.exports = __webpack_public_path__ + "img/mu.95d96af8.jpg";